import { render, staticRenderFns } from "./SalesYellDigitalListTop.vue?vue&type=template&id=8a0c23aa&scoped=true&"
import script from "./SalesYellDigitalListTop.vue?vue&type=script&lang=js&"
export * from "./SalesYellDigitalListTop.vue?vue&type=script&lang=js&"
import style0 from "./SalesYellDigitalListTop.vue?vue&type=style&index=0&id=8a0c23aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c23aa",
  null
  
)

export default component.exports